import * as Yup from 'yup';
import { Stack } from '@mui/material';

import { CasReactHookFormDialog, CasRHFAutocomplete } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
// Direct path, not the application barrel - see CasAccountPopover.
import { useImpersonate } from 'src/compass/application/general/hooks/useImpersonation';

type IUserOption = { id: number; name: string };

const schema = Yup.object().shape({
  // CasRHFAutocomplete stores the picked {id, name} option.
  user: Yup.mixed().test(
    'user-required',
    'User is required.',
    (value) => !!(value as IUserOption | null)?.id
  ),
});

interface ImpersonateUserDialogProps {
  onClose: VoidFunction;
}

/** Picks an active AD user to impersonate. Support users aren't offered admins. */
export default function ImpersonateUserDialog({ onClose }: ImpersonateUserDialogProps) {
  const { data, isLoading } = useRetrieve({ url: 'Login/Impersonate/Select/List' });
  const { impersonate, isPending } = useImpersonate();

  return (
    <CasReactHookFormDialog
      open
      title="Impersonate"
      maxWidth="xs"
      schema={schema}
      defaultValues={{ user: null }}
      onClose={onClose}
      onSubmit={(values) => impersonate(values.user.id)}
      submitButtonLabel="Impersonate"
      buttonProps={{ disabled: isPending }}
    >
      <Stack mt={1}>
        <CasRHFAutocomplete
          name="user"
          label="User"
          options={(data?.result ?? []) as IUserOption[]}
          loading={isLoading}
        />
      </Stack>
    </CasReactHookFormDialog>
  );
}
